import { Checkbox, Flex, Form, Input, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import {
  NEEDS_INFO_CATEGORIES,
  NEEDS_INFO_CATEGORY_ORDER,
  type NeedsInfoCategory,
  needsInfoCategoryHint,
  needsInfoCategoryLabel
} from "../../../constants/needs-info.ts"

const { Text } = Typography

function NeedsInfoCategoryRow({ category }: { category: NeedsInfoCategory }) {
  const { t } = useTranslation()
  const isOther = category === NEEDS_INFO_CATEGORIES.OTHER
  const hint = needsInfoCategoryHint(t, category)

  return (
    <Form.Item noStyle shouldUpdate>
      {({ getFieldValue }) => {
        const selected = !!getFieldValue(["needs_info", category, "selected"])
        return (
          <div>
            <Form.Item name={["needs_info", category, "selected"]} valuePropName={"checked"} noStyle>
              <Checkbox>
                <Text>{needsInfoCategoryLabel(t, category)}</Text>
                {hint && (
                  <Text type={"secondary"} className={"ml-1 text-xs"}>
                    ({hint})
                  </Text>
                )}
              </Checkbox>
            </Form.Item>

            {selected && (
              <Form.Item
                preserve={false}
                name={["needs_info", category, "description"]}
                className={"mt-1 mb-0 ml-6"}
                rules={
                  isOther
                    ? [
                        {
                          validator: (_, value) =>
                            value?.trim()
                              ? Promise.resolve()
                              : Promise.reject(
                                  new Error(
                                    t(
                                      "leadWorkspace.header.states.needsInfo.otherRequired"
                                    )
                                  )
                                )
                        }
                      ]
                    : undefined
                }
              >
                <Input.TextArea
                  autoSize={{ minRows: 1, maxRows: 3 }}
                  placeholder={
                    isOther
                      ? t("leadWorkspace.header.states.needsInfo.otherPlaceholder")
                      : t("leadWorkspace.header.states.needsInfo.descriptionPlaceholder")
                  }
                />
              </Form.Item>
            )}
          </div>
        )
      }}
    </Form.Item>
  )
}

interface NeedsInfoFieldsProps {
  visible: boolean
}

function NeedsInfoFields({ visible }: NeedsInfoFieldsProps) {
  const { t } = useTranslation()

  if (!visible) return null

  return (
    <div className={"rounded-card border border-border p-3 mb-4"} data-testid={"needs-info-fields"}>
      <Text type={"secondary"} className={"block mb-3 text-xs"}>
        {t("leadWorkspace.header.states.needsInfo.intro")}
      </Text>
      <Flex vertical gap={10}>
        {NEEDS_INFO_CATEGORY_ORDER.map((category) => (
          <NeedsInfoCategoryRow key={category} category={category} />
        ))}
      </Flex>
    </div>
  )
}

export { NeedsInfoFields }
